import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=b231cfec&scoped=true&"
import script from "./feeDetail.vue?vue&type=script&lang=js&"
export * from "./feeDetail.vue?vue&type=script&lang=js&"
import style0 from "./feeDetail.vue?vue&type=style&index=0&id=b231cfec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b231cfec",
  null
  
)

export default component.exports